import { Image } from 'react-native';

import DarkFoundationImages from '@vfgroup-oneplatform/foundation/Components/Themes/Modes/Dark/Images';

import Images from '../Light/Images';

const images = {
  ...Images,
  ...DarkFoundationImages,

  ic_chevron_left_black_white: Image.resolveAssetSource(
    require('../../../Assets/Images/icChevronLeftWhite.png'),
  ),
  ic_chevron_right_black_white: Image.resolveAssetSource(
    require('../../../Assets/Images/icChevronRightWhite.png'),
  ),
  active_store_marker: Image.resolveAssetSource(
    require('../../../Assets/Images/storeMarkerDark.png'),
  ),
  store_marker: Image.resolveAssetSource(require('../../../Assets/Images/blue_dot.png')),
  ic_shop: Image.resolveAssetSource(require('../../../Assets/Images/icShopWhite.png')),
  ic_payment_red: Image.resolveAssetSource(require('../../../Assets/Images/icPaymentDark.png')),
  ic_home: Image.resolveAssetSource(require('../../../Assets/Images/icHomeWhite.png')),
  edit_pen: Image.resolveAssetSource(require('../../../Assets/Images/icEditOrange.png')),
  edit_pen_two: Image.resolveAssetSource(require('../../../Assets/Images/icEditCoral.png')),
  ic_delete: Image.resolveAssetSource(require('../../../Assets/Images/icDeleteOrange.png')),
  ic_bulb: Image.resolveAssetSource(require('../../../Assets/Images/ic_bulb_white.png')),
  icCvv: Image.resolveAssetSource(require('../../../Assets/Images/cvv.png')),
  icAccelerationMid: Image.resolveAssetSource(
    require('../../../Assets/Images/icAccelerationMidDark.png'),
  ),
  icHalfHashedCircle: Image.resolveAssetSource(
    require('../../../Assets/Images/icDisplayModeDark.png'),
  ),
  icCalendarRed: Image.resolveAssetSource(require('../../../Assets/Images/icCalendarRed.png')),
  icDemmedRemove: Image.resolveAssetSource(
    require('../../../Assets/Images/icDemmedRemoveDark.png'),
  ),
  ic_remove: Image.resolveAssetSource(require('../../../Assets/Images/icRemoveDark.png')),
  ic_add_red: Image.resolveAssetSource(require('../../../Assets/Images/icAddDark.png')),
  ic_rearrange: Image.resolveAssetSource(require('../../../Assets/Images/icRearrangeDark.png')),
  dashboard_options_number1: Image.resolveAssetSource(
    require('../../../Assets/Images/number1_dark.png'),
  ),
  dashboard_options_number2: Image.resolveAssetSource(
    require('../../../Assets/Images/number2_dark.png'),
  ),
  icBiometricAuthentication: Image.resolveAssetSource(
    require('../../../Assets/Images/iconsIndicatorsSystemIconsBadge32LightBkgd.png'),
  ),
  icon_bill_report_generic: Image.resolveAssetSource(
    require('../../../Assets/Images/icon_bill_report_generic_dark.png'),
  ),
  ic_compare_plans: Image.resolveAssetSource(require('../../../Assets/Images/icBundles.png')),
  icAdminRed: Image.resolveAssetSource(require('../../../Assets/Images/icAdminRed.png')),
  dataSharing: Image.resolveAssetSource(require('../../../Assets/Images/dataSharingDark.png')),
  ic_voucher_camera_button: Image.resolveAssetSource(
    require('../../../Assets/Images/ic_camera_dark.png'),
  ),
  ic_voucher_qr_button: Image.resolveAssetSource(
    require('../../../Assets/Images/qr_code_dark.png'),
  ),
  ic_voucher_top_up: Image.resolveAssetSource(require('../../../Assets/Images/top_up_dark.png')),
};

export default images;
